import React from "react";
import { Form, Col, InputGroup  } from "react-bootstrap";
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import { ApplicantContainer} from "../unstated/applicant";
import SectionHeader from "../containers/SectionHeader";
import "react-datepicker/dist/react-datepicker.css";
import { ADULT_AGE, APPLICANT_MAX_AGE, APPLICANT_MIN_AGE } from "../config/common";
import strip from "striptags";

export default function BasicInfo({setMessage, setShowSpinner, setShowCloseButton, setModalShow}) {

  let app = ApplicantContainer.useContainer();
  
  

  function handleChange(evt) {

    if(evt.target.name === 'frMobileNo') 
      evt.target.value = evt.target.value.replace(/\D/g,'');
    
    if(evt.target.name === 'frICPassport') 
      evt.target.value = evt.target.value.replace(/[^a-z0-9]/gi,'');
  
    evt.target.value = strip(evt.target.value);
   
    app.onChangeInStdValues({...app.inStdValues, [evt.target.id]:evt.target.value});
  }

  function setDOBDate(date) {
       
    
    app.onChangeInStdValues({...app.inStdValues, frDOB: dayjs(date).format('DD-MMM-YYYY'), frDateOfBirth: date});
  
   
    const years = dayjs().diff(date, 'years');
                  
    if(years < ADULT_AGE) {
      app.setShowParentGuardian(true); 
     
      setMessage('You are ' + years + ' years old! Please get consent from your parent/guardian and provide the details under Parent/Guardian section.');
      setShowSpinner(false);
      setShowCloseButton(true);
      setModalShow(true);

    }  else {
      app.setShowParentGuardian(false); 
    } 


  }
  let strSectionHeader = "SECTION A: PERSONAL INFORMATION";

  const CustomDatePicker = React.forwardRef(({ value, onClick, onChange }, ref) => (
    <InputGroup>
    <Form.Control required type="text" aria-describedby="basic-addon1" value={value} onChange={onChange} name="frDOB"  onClick={onClick} ref={ref}  autoComplete="off"/>
    <InputGroup.Append><InputGroup.Text onClick={onClick} ref={ref}>
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" className="bi bi-calendar3" viewBox="0 0 16 16">
    <path d="M14 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM1 3.857C1 3.384 1.448 3 2 3h12c.552 0 1 .384 1 .857v10.286c0 .473-.448.857-1 .857H2c-.552 0-1-.384-1-.857V3.857z"/>
    <path d="M6.5 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm-9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"/>
    </svg></InputGroup.Text>
    </InputGroup.Append>       
    <Form.Control.Feedback type="invalid">
      Please provide your date of birth.
    </Form.Control.Feedback>           
    </InputGroup>
  ));

  let clauseStr = '';
  let ICLabel = '';
  let personalInfoClause = '';
  let invalid_personalInfoClause = '';
  if (app.showScholarshipType == "int"){
    clauseStr = 'Enter Name as per Passport';
    ICLabel = 'Passport No.';
    personalInfoClause = '';
    invalid_personalInfoClause = 'Please enter your Passport No.';
  }else if(app.showScholarshipType == "mix"){
    clauseStr = 'Enter Name as per NRIC/Passport';
    ICLabel = 'NRIC/Passport No.';
    personalInfoClause = 'NRIC for Malaysian students/ Passport no. for International students';
    invalid_personalInfoClause = 'Please enter your NRIC or Passport No.';
  }else{
    clauseStr = 'Enter Name as per NRIC';
    ICLabel = 'NRIC';
    personalInfoClause = '';
    invalid_personalInfoClause = 'Please enter your NRIC';
  }
  

    return (
      <>
      <SectionHeader strSectionHeader={strSectionHeader} />

      <Form.Row>
        <Col xs={12} sm={6}>
        <Form.Row>
            <Col xs={12} sm={2}>
            <Form.Group as={Col} htmlFor="frName">            
              <Form.Label>Name</Form.Label>      
            </Form.Group>
            </Col>
            <Col xs={12} sm={10}>      
            <Form.Group as={Col} controlId="frName">
              <Form.Control required type="text" placeholder={clauseStr} name="frName"
              onChange={handleChange}
              value={app.inStdValues.frName}  
               />
               <Form.Control.Feedback type="invalid">
                  Please enter your full name.
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
        </Form.Row>
        </Col>
        <Col xs={12} sm={6}>
        <Form.Row>
            <Col xs={12} sm={4}>
            <Form.Group as={Col} htmlFor="frICPassport">            
              <Form.Label>{ICLabel}</Form.Label>      
            </Form.Group>
            </Col>
            <Col xs={12} sm={8}>      
            <Form.Group as={Col} controlId="frICPassport">
              <Form.Control required type="text" placeholder="" name="frICPassport"
               onChange={handleChange}
               value={app.inStdValues.frICPassport}   
                />
              <Form.Control.Feedback type="invalid">
              {invalid_personalInfoClause}
            </Form.Control.Feedback>
            <div class='icpassport-clause'>{personalInfoClause}</div>
              </Form.Group>
            </Col>
        </Form.Row>
        </Col>
        
      </Form.Row>    

      <Form.Row className="flex">
            <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frEmail" >
                <Form.Label>Email</Form.Label>
                <Form.Control required type="text" name="frEmail" onChange={handleChange} value={app.inStdValues.frEmail}/>
                <Form.Control.Feedback type="invalid">
                  Please enter your email address.
                </Form.Control.Feedback>  
            </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frMobileNo" >
                <Form.Label>Mobile No.</Form.Label>
                <Form.Control required type="text" name="frMobileNo" onChange={handleChange} value={app.inStdValues.frMobileNo}/>
                <Form.Control.Feedback type="invalid">
                  Please enter Mobile No.
                </Form.Control.Feedback>   
            </Form.Group>
            </Col>
            <Col xs={12} sm={4}>
                <Form.Group as={Col} controlId="frDOB" >
                <Form.Label>Date Of Birth</Form.Label>
                <DatePicker id="frDOB" name="frDOB" ariaRequired ariaInvalid
                    dateFormat="dd-MMM-yyyy"
                    selected={app.inStdValues.frDateOfBirth}                 
                    onChange={(date) => {setDOBDate(date)}}
                    peekNextMonth
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    minDate={dayjs().subtract(APPLICANT_MAX_AGE,'years').toDate()}
                    maxDate={dayjs().subtract(APPLICANT_MIN_AGE,'years').toDate()}
                    className="form-control"
                    customInput={<CustomDatePicker />}
              />
            </Form.Group>
            </Col>           
        </Form.Row>
     
        {app.inStdValues.frScholarship == 'TSDSDJC' || app.inStdValues.frScholarship == 'ACE' ?
          ""
        : 
        <Form.Row>
          <Col xs={12} md={12}  lg={12}>
            <Form.Group as={Col} htmlFor="frHomeAddr" controlId="frHomeAddr" >
              <Form.Label>Home Address</Form.Label>
              <Form.Control required as="textarea" rows={3} 
                               onChange={handleChange}
                               value={app.inStdValues.frHomeAddr}   
                               name="frHomeAddr"
                                />
            <Form.Control.Feedback type="invalid">
              Please enter your full home address.
            </Form.Control.Feedback>                                  
            </Form.Group>
          </Col>
        </Form.Row>
        }
      </>
    );
}